import {COMMON_SET_SNACK, COMMON_GET_CONFIG_PAGE} from "~/store/mutations.type";
import ApiService from "~/common/service.api";
import {getErrorMsg} from "~/common/helper.string";
import {CONFIG_PAGE, CONFIG_OTHER_PAGE} from "../actions.type";

const state = {
    config_page : {}
};

// getters
const getters = {
    config_page: state => state.config_page
};

// actions
const actions = {
    [CONFIG_PAGE]({commit}) {
        return new Promise((resolve) => {
            ApiService.get("config-page")
                .then(resp => {
                    if (resp.data.success) {
                        resolve(resp.data.data);
                        // commit(COMMON_GET_CONFIG_PAGE, resp.data.data);
                    } else {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch((err) => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        });
    },

    [CONFIG_OTHER_PAGE]({commit}) {
        return new Promise((resolve) => {
            ApiService.get("config-other-page")
            .then(resp => {
                if (resp.data.success) {
                    resolve(resp.data.data);
                } else {
                    commit(COMMON_SET_SNACK, {
                        message: resp.data.message,
                        type: "error"
                    });
                    resolve(false);
                }
            })
            .catch((err) => {
                commit(COMMON_SET_SNACK, {
                    message: getErrorMsg(err),
                    type: "error"
                });
                resolve(false);
            });
        });
    }
};


// mutations
const mutations = {
    [COMMON_GET_CONFIG_PAGE](state) {
        state.config_page = state;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};
